// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
export const noop = (..._: any[]): void | Promise<void> => {}
